export default "__VITE_ASSET__Di1Jx8Y4__"